import styled from 'styled-components';

export const StyledCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.background.main};
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  padding: 4.6rem;
  border-radius: ${({ theme }) => theme.radius.small};
  gap: 1rem;
`;

export const StyledSearchMessageTitle = styled.p`
  font-size: 1.8rem;
  font-style: normal;
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledSearchMessageSubtitle = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-style: normal;
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
  color: ${({ theme }) => theme.colors.text.light};
  text-align: center;
`;
